var styles = {"tab":"styles_tab__jbs2I","ellipsize":"styles_ellipsize__D9EHW","disabled":"styles_disabled__0v-T3","primary":"styles_primary__06B2E","active":"styles_active__8pNUz","secondary":"styles_secondary__Q2pRc","step":"styles_step__9OjDy","ellipsizeContainer":"styles_ellipsize-container__oVy-a","borderWrapper":"styles_border-wrapper__k4O7q"};

export { styles as default };
//# sourceMappingURL=styles.css.js.map
